import React, { useContext, useEffect, useState } from 'react'
import { PodcastAllOptionsContext } from '../context/PodcastAllOptionsContext'
import Sport1 from '../assets/Sports1.png'
import Sport2 from '../assets/Sports2.png'
import Sport3 from '../assets/Sports3.png'
import Sport4 from '../assets/Sports4.png'
import shift from '../assets/shift.mp3'
import { GrCirclePlay } from "react-icons/gr";
import news1 from '../assets/NewsImage.png'
import news2 from '../assets/NewsImage2.png'
import { NavbarContext } from '../context/NavbarContext'
import { AiFillLike } from "react-icons/ai";
import { AiFillDislike } from "react-icons/ai";
import { RiReplay30Fill } from "react-icons/ri";
import { IoShareSocialOutline } from "react-icons/io5";
import { RiForward30Line } from "react-icons/ri";
import singlePodcast1 from '../assets/singlepodcast1.png'
import singlePodcast2 from '../assets/singlepodcast2.png'
import singlePodcast3 from '../assets/singlepodcast3.png'
import AudioPlayer from './AudioPlayer'
import { getAppData } from '../apiService'
import { ApiContext } from '../context/ApiContext'
import { ShimmerContentBlock, ShimmerSectionHeader, ShimmerSimpleGallery, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects'

function News() {
    const { navHeading, setNavHeading } = useContext(NavbarContext)
    const { singlePodcastId, setSinglePodcastId } = useContext(PodcastAllOptionsContext)
    const { myNews } = useContext(ApiContext)
    // const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [trending, setTrending] = useState([])
    const [image, setImage] = useState(null);
    const [content, setContent] = useState(null);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);




    const SportsAllValue = [
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
        { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
        { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
        { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
        { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },

    ]

    const morePodcasts = [
        { id: "ojfewi1", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
        { id: "ojfewi2", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
        { id: "ojfewi3", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
        { id: "ojfewi4", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },


    ]
    const myMorePodcastslength = Math.ceil(morePodcasts.length / 2)
    const allMoreProdcast1 = morePodcasts.slice(0, myMorePodcastslength)
    const allMoreProdcast2 = morePodcasts.slice(myMorePodcastslength, morePodcasts.length)
    // console.log(allMoreProdcast1);
    // console.log(allMoreProdcast2);
    function formatDate() {
        const date = new Date();
        const options = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }



    useEffect(() => {
        if (myNews) {
            // console.log(myNews,"data is ");

            setImage(myNews[0].image);
            setContent(myNews[0].content);
            setTitle(myNews[0].title);
            setDescription(myNews[0].description);
            setTrending(myNews.filter((item) => item.isTrending == 1))
        }
    }, [myNews])

    useEffect(() => {
        const podcast = SportsAllValue.find(item => item.id === singlePodcastId);
        const podcastName = podcast ? podcast.name : null;

        // console.log(podcastName);

    })

    const handleClick = (id) => {
        const fullnews = myNews.find((item) => item.id == id);

        if (fullnews) {
            setContent(fullnews.content);
            setImage(fullnews.image)
            setDescription(fullnews.description)
            setTitle(fullnews.title)
        }
        // console.log(image);
        window.scrollTo({ top: 0, behavior: 'smooth' });

    }
    if (!myNews) {
        return (
            <div className='layout5-div'>
                <div className='shimmer-News-for-laptop'>
                    <div className='news-internal-main-div'>
                        <div className='news-internal-left-side-div'>
                            <p className='news-internal-left-main'>Recent news</p>
                            <hr className='news-internal-hr1' />
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                        </div>
                        <div className='news-internal-center-div'>
                            <div className='news-internal-bg-with-content-div'>
                                {/* <ShimmerSimpleGallery card imageHeight={800} caption /> */}
                                <ShimmerThumbnail height={450} rounded />
                                <div>
                                    <ShimmerText line={3} gap={10} />
                                </div>
                            </div>
                        </div>
                        <div className='news-internal-left-right-div'>
                            <p className='news-internal-left-main'>Trending news</p>
                            <hr className='news-internal-hr1' />
                            <div className='news-all-options-paras-and-image'>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    /></div>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    /></div>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    /></div>
                            </div>

                        </div>
                    </div>

                </div>
                <div className='shimmer-News-for-mobile'>
                    <div className='news-internal-main-div'>
                        <div className='news-internal-bg-with-content-div'>
                            <ShimmerThumbnail height={250} rounded />
                            <div>
                                <ShimmerText line={3} gap={10} />
                            </div>
                        </div>
                        <div className='news-internal-left-right-div'>
                            <p className='news-internal-left-main'>Trending news</p>
                            <hr className='news-internal-hr1' />
                            <div className='news-all-options-paras-and-image'>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    />
                                </div>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    />
                                </div>
                                <div className='main-inner-recently-played-all-recently-played-here1'>
                                    <ShimmerContentBlock
                                        title
                                        text
                                        cta
                                        thumbnailWidth={170}
                                        thumbnailHeight={170}
                                        style={{ marginBottom: "10px" }}
                                    /></div>
                            </div>

                        </div>
                        <div className='news-internal-left-side-div1'>
                            <p className='news-internal-left-main'>Recent news</p>
                            <hr className='news-internal-hr1' />
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                            <div className='main-inner-recently-played-all-recently-played-here1'>
                                <ShimmerContentBlock
                                    title
                                    text
                                    cta
                                    thumbnailWidth={170}
                                    thumbnailHeight={170}
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    if (error) {
        return (
            <>
                <div className="blur-background"></div>
                <div className="error-container">
                    <p>{error}</p>
                </div>
            </>
        )
    }


    return (
        <>
            {myNews ? (<div className='layout5-div'>
                {/* pod id : {singlePodcastId} */}
                <div className='news-internal-main-div'>
                    <div className='news-internal-left-side-div'>
                        <p className='news-internal-left-main'>Recent news</p>
                        <hr className='news-internal-hr' />
                        <hr className='news-internal-hr1' />
                        {myNews.map((item) => (
                            <div className='news-internal-left-side-internal' key={item.id} onClick={() => handleClick(item.id)} >  {/*  loop this */}
                                <div className='news-internal-more-podcast-img-and-para'>
                                    <div className='news-internal-more-podcast-img-ghwsghq-1234' >
                                        <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                    <div className='news-internal-more-podcast-paras'>
                                        <p className='news-internal-more-podcast-para1'>{item.title.length > 55 ? item.title.substring(0, 53) + '...' : item.title}</p>
                                        <p className='news-internal-more-podcast-para2'>{item.author}</p>
                                        <p>{item.created_at}</p>
                                    </div>
                                </div>
                                <hr className='news-internal-hr' />
                            </div>
                        ))}
                    </div>
                    <div className='news-internal-center-div'>
                        <div>
                            <div className='news-internal-bg-with-content-div'>
                                <img src={image} alt={image} />
                            </div>
                            <h2 className='news-internal-bg-with-content-title-h2'>{title}</h2>
                            <p
                                className='news-internal-bg-with-content-main-para-gjh'
                                dangerouslySetInnerHTML={{ __html: description }}
                            ></p>
                            <br />
                            <p className='news-internal-bg-with-content-main-para-gjh'>{content}</p>
                        </div>
                    </div>
                    <div className='news-phone-screen-special-div1'><p className='news-phone-screen-special-div1-para1'>Main news</p> <p className='news-phone-screen-special-div1-para2'>{formatDate()}</p>

                    </div>
                    {/* <div className='news-internal-outer-div'>
                    <div className='news-internal-center-div1'>
                        <div className='news-internal-bg-with-content-div1'><img src={news1} alt="news1" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>
                        <div className='news-internal-bg-with-content-div1'><img src={news2} alt="news2" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>
                        <div className='news-internal-bg-with-content-div1'><img src={news1} alt="news1" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>
                        <div className='news-internal-bg-with-content-div1'><img src={news2} alt="news2" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>
                        <div className='news-internal-bg-with-content-div1'><img src={news1} alt="news1" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>
                        <div className='news-internal-bg-with-content-div1'><img src={news2} alt="news2" style={{ width: "100%", height: "100%", borderRadius: "30px" }} /></div>

                    </div>
                </div> */}
                    <div className='news-internal-outer-div'>
                        <div>
                            <div className='news-internal-bg-with-content-div'>
                                <img src={image} alt={image} />
                            </div>
                            <h2 className='news-internal-bg-with-content-title-h2'>{title}</h2>
                            <p className='news-internal-bg-with-content-main-para-gjh' dangerouslySetInnerHTML={{ __html: description }} ></p>
                            <br />
                            <p className='news-internal-bg-with-content-main-para-gjh'>{content}</p>
                        </div>
                    </div>


                    {/* <div className='news-phone-screen-special-div2'> */}
                    {/* <p className='news-phone-screen-special-div2-para1'>Today’s posts</p> */}
                    {/* {morePodcasts.map((item) => ( */}
                    {/* // <div className='news-internal-right-side-internal'>   */}
                    {/* <div className='news-phone-screen-special-div2-internal-div1'> */}
                    {/* <img src={item.image} alt="singlepodcast" /> */}
                    {/* <div className='news-phone-screen-special-div2-Internal-div2'> */}
                    {/* <div style={{ marginLeft: "8px" }}> */}
                    {/* <p className='news-internal-more-podcast-para1'>{item.heading}</p> */}
                    {/* <p className='news-internal-more-podcast-para2'>{item.author} </p> */}
                    {/* </div> */}
                    {/* <GrCirclePlay /> */}
                    {/* </div> */}
                    {/* </div> */}
                    {/* </div> */}
                    {/* // ))} */}


                    {/* </div> */}


                    <div className='news-internal-left-right-div'>
                        <p className='news-internal-left-main'>Trending news</p>
                        <hr className='news-internal-hr' />
                        <hr className='news-internal-hr1' />
                        <div className='news-all-options-paras-and-image'>
                            {trending.map((item) => (
                                <div className='news-internal-right-side-internal' key={item.id} onClick={() => handleClick(item.id)}>  {/*  loop this */}
                                    <div className='news-internal-more-podcast-img-and-para'>
                                        <div className='news-internal-more-podcast-img-ghwsghq-1234' >
                                            <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%" }} />
                                        </div>
                                        <div className='news-internal-more-podcast-paras'>
                                            <p className='news-internal-more-podcast-para1'>{item.title.length > 55 ? item.title.substring(0, 53) + '...' : item.title}</p>
                                            <p className='news-internal-more-podcast-para2'>{item.author}</p>
                                            <p>{item.created_at}</p>
                                        </div>
                                    </div>
                                    <hr className='news-internal-hr' />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='news-internal-left-side-div1'>
                        <p className='news-internal-left-main'>Recent news</p>
                        <hr className='news-internal-hr' />
                        <hr className='news-internal-hr1' />
                        {myNews.map((item) => (
                            <div className='news-internal-left-side-internal' key={item.id} onClick={() => handleClick(item.id)} >  {/*  loop this */}
                                <div className='news-internal-more-podcast-img-and-para'>
                                    <div className='news-internal-more-podcast-img-ghwsghq-1234' >
                                        <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                    <div className='news-internal-more-podcast-paras'>
                                        <p className='news-internal-more-podcast-para1'>{item.title.length > 55 ? item.title.substring(0, 53) + '...' : item.title}</p>
                                        <p className='news-internal-more-podcast-para2'>{item.author}</p>
                                        <p>{item.created_at}</p>
                                    </div>
                                </div>
                                <hr className='news-internal-hr' />
                            </div>
                        ))}
                    </div>

                    {/* <div className='news-internal-left-right-div-only-for-phone'>
                  <p className='news-internal-left-main-only-for-phone'>Recent news</p>
                  <hr className='news-internal-hr-only-for-phone' />
                  <div className='news-all-options-paras-and-image-only-for-phone'>
                  <div className='news-all-options-paras-and-image-only-for-phone1'>
                  {allMoreProdcast1.map((item) => (
                      <div className='news-internal-right-side-internal-only-for-phone'>  
                          <div className='news-internal-more-podcast-img-and-para-only-for-phone'>
                              <img src={item.image} alt="singlenews-only-for-phone" />
                              <div className='news-internal-more-podcast-paras-only-for-phones'>
                                  <p className='news-internal-more-podcast-para1-only-for-phone'>{item.heading}</p>
                                  <p className='news-internal-more-podcast-para2-only-for-phone'>{item.author} <GrCirclePlay /></p>
                              </div>
                          </div>
                          <hr className='news-internal-hr' />
                      </div>
                  ))}
                  </div>
                  
                  <div className='podcast-all-options-paras-and-image-only-for-phone2'>
                  {allMoreProdcast2.map((item) => (
                      <>
                     
                     
                      <div className='news-internal-right-side-internal-only-for-phone'>  
                          <div className='news-internal-more-podcast-img-and-para-only-for-phone'>
                              <img src={item.image} alt="singlenews-only-for-phone" />
                              <div className='podcast-internal-more-podcast-paras-only-for-phone'>
                                  <p className='news-internal-more-podcast-para1-only-for-phone'>{item.heading}</p>
                                  <p className='news-internal-more-podcast-para2-only-for-phone'>{item.author} <GrCirclePlay /></p>
                              </div>
                          </div>
                          <hr className='news-internal-hr' />
                      </div>
                      </>
                  ))}
                  </div>
                  </div>
              </div> */}
                </div>
            </div>) : (<div className='layout5-div'>No new found</div>)}
        </>
    )
}

export default News